module.exports = __webpack_public_path__ + "static/media/logoAdmin.7534c94b.svg";